import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

// MESSAGES
import NewCustomerReportFormattedMessages from '../../../messages/billing/NewCustomerReportFormattedMessages';

const CancelledCustomerTable = ({ totals, listCancelledCustomers }) => {
  if (!listCancelledCustomers || listCancelledCustomers.length === 0)
    return 'No cancelled customers found for the given month';

  return (
    <TableContainer sx={{ marginBottom: 4, overflowX: 'auto', width: '100%' }}>
      <Table
        sx={{
          whiteSpace: 'nowrap',
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell>
              {NewCustomerReportFormattedMessages.createdDate}
            </TableCell>
            <TableCell>{NewCustomerReportFormattedMessages.date}</TableCell>
            <TableCell>
              {NewCustomerReportFormattedMessages.customerID}
            </TableCell>
            <TableCell>
              {NewCustomerReportFormattedMessages.customerName}
            </TableCell>
            <TableCell>
              {NewCustomerReportFormattedMessages.customerType}
            </TableCell>
            <TableCell>
              {NewCustomerReportFormattedMessages.customerLocation}
            </TableCell>
            <TableCell>{NewCustomerReportFormattedMessages.agent}</TableCell>
            <TableCell>
              {NewCustomerReportFormattedMessages.cancelled}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listCancelledCustomers}
          <TableRow
            sx={{
              '& .MuiTableCell-root': {
                backgroundColor: 'primary.light',
                fontWeight: 700,
                color: 'primary.main',
              },
            }}
          >
            <TableCell colSpan={7}>
              {NewCustomerReportFormattedMessages.total}
            </TableCell>
            <TableCell colSpan={1}>
              {totals.totalUsers !== 0 ? '-' : ''}
              {totals.totalUsers} Users
              <br />
              {totals.Cancelled !== 0 ? '-' : ''}
              {totals.Cancelled} Customers
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CancelledCustomerTable;
